import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      label: '客户姓名',
      field: 'customerName',
      type: 'input',
      placeholder: '请输入客户姓名'
    },
    {
      label: '客户昵称',
      field: 'customerNick',
      type: 'input',
      placeholder: '请输入客户昵称'
    },
    {
      label: '性别',
      type: 'select',
      field: 'sex',
      clearable: true,
      placeholder: '请选择性别',
      options: [
        {title: '男', value: 0},
        {title: '女', value: 1}
      ]
    },
    {
      label: '开发关键词',
      field: 'developInfo',
      type: 'input',
      placeholder: '请输入开发信息关键词',

    },
    {
      label: '客户关键词',
      field: 'customerInfo',
      type: 'input',
      placeholder: '请输入客户信息关键词',
    }
  ]
}
